// redirect after 10s to homepage if current page is thankYou
function thankYouPage() {
  var path = window.location.href;
  if (
    path.indexOf('/dekujeme/') >= 0 ||
    path.indexOf('/thank-you-for-order/') >= 0
  ) {
    var t = setTimeout(function () {
      window.location.replace($('#homepage-url').val());
    }, 10000);
  }
}
